<div [ngClass]="RightOverlay==true?'rightOverlayPadding' :'generalPage'" *ngIf="outcome">
  <div class="ptb-archive highlightSearchTerm" *ngIf="!RightOverlay">
    <div class="flex-display">
      <div class="cursor-pointer" (click)="BackToCurrentVersion()">
        <img src="../../../../assets/icons/Arrow Left.svg" class="whatsNew-image image-info" alt="Archive">
      </div>
      <div class="h-20px check-yesno-if-the-pro cursor-pointer" (click)="BackToCurrentVersion()">
        {{archive_back}}
      </div>
    </div>
    <div class="mt-12 ml-1-5 flex-display">
      <div class="archive-btn">
        <span class="version-general-header" [innerHTML]='archive_version.toString().replace("[VERSION_NUM]",version)'></span>&nbsp;|&nbsp;
        <span class="archive-Info" [innerHTML]='archive_asOf.toString().replace("[DATE]",versionDate)'></span>
      </div>
    </div>
  </div>
  <div [ngClass]="RightOverlay==true?'width-93 ml-invert-1': 'archive-screen-padding'">
    <div class="componentHeader pb-1rem" *ngIf="RightOverlay==true">
      <app-breadcrumbs-path [navData]="navData"></app-breadcrumbs-path>
    </div>
    <div class="componentHeader mb-2">
      <h1 id="pageHeading" role="main" [ngClass]="RightOverlay==true?'rightOverlaygeneralHeader':'generalHeader'" [innerHTML]="pageHeading">
      </h1>
    </div>

    <div *ngFor="let para of paragraphTitleContent">
      <div class="componentHeader flex-display topicBody print-all-content mt_1" *ngIf="para.title.topicTitleName != ''">
        <div class="width-75" tabindex="0" [id]="para.title.topicTitleId">
          <h2 class="paraHeader">
            <span [innerHTML]="para.title.topicTitleName"></span>
          </h2>
        </div>
      </div>

      <div class="componentHeader" *ngFor="let paragraph of para.paragraphContent">
        <div class="componentHeaderPrint print-all-content">
          <div class="mt_1 width-90" [ngClass]="paragraph.paraTitle == null?'mb-1-5':'mb-1'">
            <h3 *ngIf="paragraph.paragroup != ''" class="annotation-content-title topicBody">
              <span [innerHTML]="paragraph.paragroup"></span>
            </h3>
          </div>
        </div>
        <pub-dita-content [id]="paragraph.id" [dita]="paragraph.paraContent" [s3ImageBasePath]="s3ImageBasePath" [paraTitle]="paragraph.paraTitle" [annotationCount]="paragraph.paraAnnotationCount" [bookmarkCount]="paragraph.paraBookmarkCount" [printqueueAdd]="paragraph.PrintQueueAdded" [actionLabel]="paragraph.actionLabel" [UserInfo]="loggedInUserInfo" [archivePage]="archivePage" [paraNum]="paragraph.paraNum" [rightOverLayPage]="RightOverlay" [crossReferencedContentID]="ParaID" [topic_subtopicNum]="topic_subtopicNum"></pub-dita-content>
      </div>
    </div>  
    <div class="box"></div>
  </div>
</div>
